<template>
  <div class="router-wrap">
    <router-view :key="key"></router-view>
  </div>
</template>
<script>
export default {
  computed: {
    key() {
      return this.$route.path + Math.random();
    }
  }
}
</script>
<style scoped>
.router-wrap{
  height: 0;
  flex: 1;
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
}
</style>
